@use 'vars';
@use 'mixins';

.info-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: vars.$gap-medium;
  border: vars.$border-size-thin solid vars.$mid-grey;
  border-radius: vars.$border-radius-xlarge;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__title-group {
    display: flex;
    flex-direction: column;
    gap: vars.$gap-xsmall;

    &--with-icon {
      display: flex;
      gap: vars.$gap-small;
      align-items: center;
    }

    &--minimal {
      border: none;
    }

    &__call-to-action {
      width: fit-content;
      height: fit-content;
      margin-top: 10px !important;

      // need to use a media query here as Button uses LayoutContext
      // to determine softphone, which is not availiable in AuthScreens
      @include mixins.softphone-and-under {
        min-height: 35px !important;
      }
    }
  }

  &--primary {
    background-color: vars.$white;

    > .info-card__icon {
      background-color: vars.$secondary;
    }
  }

  &--secondary {
    background-color: vars.$secondary;
    border-color: vars.$secondary;

    > .info-card__icon {
      background-color: vars.$light-grey;
    }
  }

  &--large {
    padding: vars.$padding-medium;
    min-height: 100px;

    > .info-card__icon {
      min-width: 60px;
      min-height: 60px;
      border-radius: vars.$border-radius-huge;
    }

    .info-card--text-only {
      font-size: vars.$font-size-large !important;

      p,
      span,
      a {
        font-size: vars.$font-size-large !important;
      }
    }
  }

  &--small {
    padding-block: vars.$padding-small;
    padding-inline: vars.$padding-medium;

    > .info-card__icon {
      min-width: 40px;
      min-height: 40px;
      border-radius: vars.$border-radius-xlarge;
    }
  }

  &--minimal {
    padding: 0;
    border: 0;
    border-radius: 0;
  }
}

.info-card-group {
  display: flex;
  flex-direction: column;

  &--alternating {
    > :nth-child(even) {
      margin-left: vars.$margin-xlarge;
    }

    > :nth-child(odd) {
      margin-right: vars.$margin-xlarge;
    }
  }
}
